export const locales = {};

export class I18n {
  #url;
  #registry;
  #locale;
  #messages = {};
  constructor(lang, registryUrl) {
    this.#locale = lang.replace('-', '_');
    this.#url = new URL(registryUrl, document.baseURI).toString();
  }
  /**
   * @param {Function} cb
   * @returns {Promise}
   */
  getAcceptLanguages(cb = null) {
    let p = this.#registry;
    if (!p) {
      let url = this.#url;
      p = loadJSON(url);
      this.#registry = p;
    }
    if (typeof cb === 'function') {
      p.then((o) => {
        cb(null, Object.keys(o));
      }, cb);
    }
    return p;
  }
  /**
   * @returns {string}
   */
  getUILanguage() {
    return document.documentElement.lang;
  }
  /**
   * @param {string} key
   * @param {Object} [substitutions]
   * @param {Object} [options] like {escapeLt: false}
   * @returns {string}
   */
  getMessage(key, substitutions, options) {
    let value = this.#messages[key];
    if (value === void 0)
      throw new Error('Cannot find message with key ' + key);
    if (Array.isArray(substitutions)) {
      value = value.replace(/\$([1-9]|[a-zA-Z_]\w*\$|\$)/g, ($0, $1) => {
        if ($1.length === 1) {
          return $1 === '$' ? '$' : substitutions[+$1 - 1];
        } else {
          return substitutions[$1.slice(0, -1)];
        }
      });
    }
    if (options && options.escapeLt) {
      return value.replace(/</g, '&lt;');
    }
    return value;
  }
  async load() {
    let messages = await loadJSON(this.#url.replace(/\.json$/, '_' + this.#locale + '.json'));
    let locale = this.#locale;
    this.#messages = Object.assign(messages, {
      '@@ui_locale': locale,
      '@@bidi_dir': /^(ar|he)/.test(locale) ? 'rtl' : 'ltr',
    });
  }
}

// let supportsImportAttributes = document.createElement('details').name === '';
// supportsImportAttributes ? import(url, {with: {type:'json'}}).then(o=>o.default) :
function loadJSON(url) {
  return fetch(url, {mode: 'cors', credentials: 'omit'}).then((r) => {
    if (r.ok && /^application\/json/.test(r.headers.get('content-type'))) {
      return r.json();
    } else {
      throw new Error('Failed to load i18n registry');
    }
  });
}

